import React from 'react';

import { Form, Field } from 'react-final-form';

import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormGroupAdapter from 'components/shared/FormAdapters/FormDefault/FormGroup';
import AuthTitle from 'components/shared/Typography/AuthTitle';
import useValidationSchema from 'hooks/useValidationSchema';

import FormErrorText from '../../../shared/FormErrorText';
import styles from '../index.module.css';
import { Wrapper } from '../shared';
import { useNewPasswordForm } from './functions';
import validationSchema from './validationSchema';

const INITIAL_FORM_VALUES = {};
function NewPasswordForm({ token, method }) {
  const validate = useValidationSchema(validationSchema);
  const { handleSubmit } = useNewPasswordForm({ token, method });

  return (
    <Wrapper>
      <AuthTitle>Please create a unique password</AuthTitle>

      <Form
        onSubmit={handleSubmit}
        initialValues={INITIAL_FORM_VALUES}
        validate={validate}
        render={({ handleSubmit, submitting, submitError }) => (
          <form onSubmit={handleSubmit} autoComplete="off" className={styles.form}>
            <Field
              component={FormGroupAdapter}
              name="password"
              placeholder="Password*"
              type="password"
              withIcon
              withPasswordRequirementsTip
            />

            <Field
              component={FormGroupAdapter}
              name="confirm_password"
              placeholder="Password Confirmation*"
              type="password"
              withIcon
            />

            {submitError && <FormErrorText>{submitError}</FormErrorText>}

            <FormActions isRight>
              <Button htmlType="submit" disabled={submitting}>
                Submit
              </Button>
            </FormActions>

            {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
          </form>
        )}
      />
    </Wrapper>
  );
}

export default NewPasswordForm;
